export default function MusicWall() {
 return (
 <section
 data-testid="music-wall"
 className="relative bg-ink-800 py-24 md:py-32 border-t border-ink-600"
 >
 <div className="max-w-7xl mx-auto px-4 md:px-8">
 <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
 <div>
 <p className="tag-kicker">The catalog</p>
 <h2 className="font-display text-4xl md:text-5xl font-bold tracking-normal leading-[1.15] mt-3 max-w-2xl">
 A sampling of what{" "}
 <span className="italic text-amber">our members</span> are
 making.
 </h2>
 </div>
 <p className="text-sm text-white/55 max-w-sm">
 Tracks from Underground Mix. Many already placed on premium TV
 and brand spots.
 </p>
 </div>

 <div
 data-testid="disco-player-wrapper"
 className="relative overflow-hidden border border-ink-600 bg-ink-900 shadow-[0_20px_60px_-20px_rgba(34,197,94,0.12)]"
 >
 <iframe
 id="disco-playlist-25789776"
 name="disco-playlist-25789776"
 title="Underground Mix member catalog"
 data-testid="disco-playlist-iframe"
 allowFullScreen
 frameBorder="0"
 className="disco-embed w-full block"
 src="https://underground-mix.disco.ac/e/p/25789776?download=false&s=FtqGJYrmoMI22kOyGLlYm7tkHIQ%3ABzUbsGcr&artwork=true&color=%2322C55E&theme=dark"
 style={{ height: "620px" }}
 />
 </div>

 <p className="mt-4 text-xs text-white/40 font-mono uppercase tracking-widest">
 Playback powered by DISCO · the industry standard for sync
 </p>
 </div>
 </section>
 );
}
